// File is named with @ at the front so we can keep this file at the top of the file.
// usage => import @/@polyfills
import 'core-js/features/object/from-entries'
import 'core-js/features/promise/all-settled'
import 'intersection-observer'
import 'intl-pluralrules'
